import { render } from "./BoxWithBtn.vue?vue&type=template&id=2c989343&scoped=true&ts=true"
import script from "./BoxWithBtn.vue?vue&type=script&lang=ts"
export * from "./BoxWithBtn.vue?vue&type=script&lang=ts"

import "./BoxWithBtn.vue?vue&type=style&index=0&id=2c989343&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c989343"]])

export default __exports__